export interface UnsavedChangesRegistry {
  register(id: string, label: string): void;
  unregister(id: string): void;
  hasDirty(): boolean;
  dirtyLabels(): string[];
}

export function createUnsavedChangesRegistry(): UnsavedChangesRegistry {
  const entries = new Map<string, string>();

  return {
    register(id, label) {
      entries.set(id, label);
    },
    unregister(id) {
      entries.delete(id);
    },
    hasDirty() {
      return entries.size > 0;
    },
    dirtyLabels() {
      return [...entries.values()];
    },
  };
}
